export default __webpack_public_path__ + "static/media/ethereum.4b0d8f2d.png";